// removed by extract-text-webpack-plugin
module.exports = {"submitWrapper":"_1bOTv","disabledLink":"_2O6bY","submit":"_2Rpwj","disabled":"qCU-b","paypalSubmit":"_1iMCn","termsLink":"_1DHpu","terms":"_1_yKp"};


//////////////////
// WEBPACK FOOTER
// ./components/TermsAndSubmit/TermsAndSubmit.scss
// module id = 381
// module chunks = 0 1